import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Phone, Mail, MessageCircle, Loader2 } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { img } from "../lib/utils-app";

export default function Agents() {
  const { t, L } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/agents").then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="pt-24">
      <div className="border-b border-border bg-card/40">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14">
          <span className="label-caps text-primary">{t("nav.agents")}</span>
          <h1 className="font-serif text-4xl md:text-6xl font-light mt-3">Meet Our Advisors</h1>
          <p className="text-muted-foreground font-light mt-3 max-w-xl">A multilingual team of experts dedicated to extraordinary service at every step.</p>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
        {items.map((a) => (
          <div key={a.id} className="group flex flex-col sm:flex-row gap-6 bg-card border border-border p-6 hover:border-primary/40 transition-colors" data-testid={`agent-${a.id}`}>
            <div className="sm:w-44 aspect-[3/4] overflow-hidden flex-shrink-0 hover-zoom"><img src={img(a.photo)} alt={a.name} className="w-full h-full object-cover" /></div>
            <div className="flex flex-col">
              <p className="label-caps text-primary">{a.title}</p>
              <h2 className="font-serif text-3xl mt-1">{a.name}</h2>
              <div className="flex items-center gap-2 mt-1 text-sm text-muted-foreground">
                <span className="flex items-center gap-1 text-primary"><Star size={13} className="fill-primary" /> {a.rating}</span>
                <span>· {a.deals} deals</span>
              </div>
              <p className="text-sm text-muted-foreground font-light mt-3 leading-relaxed flex-1">{typeof a.bio === "string" ? a.bio : L(a.bio)}</p>
              <div className="flex flex-wrap gap-2 mt-3">
                {a.specialties?.map((s) => <span key={s} className="text-xs px-2 py-1 bg-secondary">{s}</span>)}
              </div>
              <div className="flex gap-2 mt-4">
                <a href={`tel:${a.phone}`} className="flex items-center gap-1.5 px-3 py-2 border border-border hover:border-primary transition-colors text-xs" data-testid={`agent-call-${a.id}`}><Phone size={13} /> {t("common.call")}</a>
                <a href={`mailto:${a.email}`} className="flex items-center gap-1.5 px-3 py-2 border border-border hover:border-primary transition-colors text-xs"><Mail size={13} /> {t("common.email")}</a>
                {a.whatsapp && (
                  <a href={`https://wa.me/${String(a.whatsapp).replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 px-3 py-2 border border-border hover:border-emerald-500 text-emerald-500 transition-colors text-xs" data-testid={`agent-whatsapp-${a.id}`}><MessageCircle size={13} /> WhatsApp</a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
